import { FormikErrors } from 'formik';
import * as yup from 'yup';

import { UserLoginType } from 'client/types';
import { translateT } from 'client/hooks';

export const InitialValues = {
  [UserLoginType.custom]: {
    email: '',
    phone: '',
  },
  [UserLoginType.regular]: {
    nickname: '',
  },
  [UserLoginType.sms]: {
    code: '',
  },
};

export type FormValuesT = { email: string; phone: string } | { nickname: string } | { code: string };

export class FormManager {
  constructor(private readonly UserType: UserLoginType, private readonly translations: translateT) {}

  public onButtonDisable = (errors: FormikErrors<FormValuesT>, values: FormValuesT): boolean => {
    return Object.values(errors).length > 0 || Object.values(values).some((value) => value === '');
  };

  public getSubmitButtonLabel = (): string => {
    switch (this.UserType) {
      case UserLoginType.custom: {
        return this.translations('form.custom.submit');
      }
      case UserLoginType.regular: {
        return this.translations('form.regular.submit');
      }
      case UserLoginType.sms: {
        return this.translations('form.regular.submit');
      }
    }

    return '';
  };

  public getValidationSchema = () => {
    const customSchema = yup.object().shape({
      email: yup
        .string()
        .email(this.translations('form.errors.wrongStructure.email'))
        .required(this.translations('form.errors.required.email')),
      phone: yup
        .string()
        .max(10, this.translations('form.errors.wrongStructure.phoneNumber'))
        .min(10, this.translations('form.errors.wrongStructure.phoneNumber'))
        .required(this.translations('form.errors.required.phoneNumber')),
    });

    const regularSchema = yup.object().shape({
      nickname: yup
        .string()
        .trim()
        .matches(
          /^[A-Za-z\u0590-\u05FF]+(?: [A-Za-z\u0590-\u05FF]+)?$/,
          this.translations('form.errors.invalid.nickname'),
        )
        .max(24, this.translations('form.errors.maxLength.nickname'))
        .required(this.translations('form.errors.required.nickname')),
      agreement: yup
        .boolean()
        .oneOf([true], this.translations('form.errors.required.checkbox'))
        .required(this.translations('form.errors.required.checkbox')),
    });

    const smsSchema = yup.object().shape({
      code: yup.string().min(6).max(6).required(),
    });

    switch (this.UserType) {
      case UserLoginType.custom: {
        return customSchema;
      }
      case UserLoginType.regular: {
        return regularSchema;
      }
      case UserLoginType.sms: {
        return smsSchema;
      }
    }
  };
}
